module.exports = __webpack_public_path__ + "img/tournament-bg_1248.eabf39fa.png";